import { Controller } from "@hotwired/stimulus";

// Selection des transactions a valider en lot.
//
// La barre d'action ne parait que lorsqu'il y a quelque chose a valider :
// un bouton toujours la, toujours grise, se clique quand meme.
export default class extends Controller {
  static targets = ["selectAll", "item", "submit", "count", "bar"];

  connect() {
    this.refresh();
  }

  toggleAll() {
    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = this.selectAllTarget.checked;
    });
    this.refresh();
  }

  toggleItem() {
    this.refresh();
  }

  refresh() {
    const total = this.itemTargets.length;
    const checked = this.itemTargets.filter((box) => box.checked).length;

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checked > 0 && checked === total;
      this.selectAllTarget.indeterminate = checked > 0 && checked < total;
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = checked === 0;
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = checked;
    }
    if (this.hasBarTarget) {
      this.barTarget.classList.toggle("hidden", checked === 0);
    }
  }
}
